import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import omit from 'lodash/omit';
import { loadReCaptcha } from 'react-recaptcha-v3';
import gettext from '@eb/gettext';

import { NotificationBar } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';
import { AlertChunky } from '@eb/eds-iconography';
import { User } from '@eb/eds-iconography';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { TYPE_ERROR } from '@eb/eds-notification';

import PageHeader from '../../components/PageHeader';
import SocialSignUpForm from '../../components/forms/SocialSignUpForm';
import AuthenticationStructure from '../../components/AuthenticationStructure';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOCIAL_SIGN_UP_PATH
 */
class SocialSignupPage extends React.PureComponent {
    static propTypes = {
        locale: PropTypes.string,
        clearAuthNotification: PropTypes.func,
        recaptcha3PublicKey: PropTypes.string,
        disableRecaptcha3: PropTypes.bool,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),
        authNotificationOptions: PropTypes.shape({
            message: PropTypes.node,
            type: PropTypes.string,
            iconType: ICON_TYPE_PROP_TYPE,
        }),
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    // Don't have a good understanding of this function yet or when is it necessary.
    forceUpdate(socialProvider, stateFromProvider) {
        const { onSocialProviderClick } = this.props;

        if (onSocialProviderClick) {
            onSocialProviderClick({
                socialProvider,
                stateFromProvider,
            });
        }
    }

    _handleSubmit = (formData) => {
        const { clearAuthNotification, onSocialSignUpUser } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return onSocialSignUpUser(formData);
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _renderAuthNotification = () => {
        const { authNotificationOptions } = this.props;

        let component = null;

        if (!isEmpty(authNotificationOptions)) {
            const { message, ...props } = authNotificationOptions;

            component = (
                <div className="eds-l-mar-top-4 eds-l-mar-bot-8 sign-in-screen__notification-container">
                    <NotificationBar {...props}>{message}</NotificationBar>
                </div>
            );
        }

        return component;
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            locale,
            socialSSOSettings,
            authNotificationOptions,
        } = this.props;

        let pageHeaderProps = {
            headerText: gettext('Welcome'),
            iconType: <User />,
            subtitleText: gettext(
                'Please confirm your email and name to continue with Facebook.',
            ),
        };
        const buttonCTA = gettext('Sign Up');

        // hide subtitle when an auth notification is being displayed
        if (!isEmpty(authNotificationOptions)) {
            pageHeaderProps = omit(pageHeaderProps, 'subtitleText');
        }

        return (
            <AuthenticationStructure>
                <>
                    <PageHeader {...pageHeaderProps} />

                    {this._renderAuthNotification()}

                    <SocialSignUpForm
                        buttonCTA={buttonCTA}
                        onSubmit={this._handleSubmit}
                        locale={locale}
                        showNotification={this._handleShowNotification}
                        clearNotification={this._handleClearNotification}
                        socialSSOSettings={socialSSOSettings}
                    />
                </>
            </AuthenticationStructure>
        );
    }
}

export default withMainControls(SocialSignupPage);
